export default "__VITE_ASSET__DYlelemT__"